import { c as _c } from "react/compiler-runtime";
import React from 'react';
import AnimateHeight from 'react-animate-height';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
const ProductClearAllFiltersButton = t0 => {
  const $ = _c(5);
  const {
    canClear,
    clearRefinement
  } = t0;
  const t1 = canClear ? "auto" : 0;
  let t2;
  if ($[0] !== clearRefinement) {
    t2 = <div className="md:pb-5"><ClearAllFiltersButton onClick={clearRefinement}>Clear all</ClearAllFiltersButton></div>;
    $[0] = clearRefinement;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <AnimateHeight duration={300} height={t1} animateOpacity={true}>{t2}</AnimateHeight>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ProductClearAllFiltersButton;